// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3fFhi","addWidgetButton":"Header_addWidgetButton__1IQZn","dashboardTabs":"Header_dashboardTabs__3OwWh","active":"Header_active__3-D88"};